<template>
	<ul class="c-project-facts">
		<li class="c-project-facts__item"
			v-for="fact in facts">
			<div class="c-project-facts__title" v-html="fact.title"></div>
			<div v-html="fact.text"></div>
		</li>
	</ul>
</template>

<script>
export default {
	name: 'project-facts',
	props: ['facts'],
	data: () => ({
	})
};
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.c-project-facts {
		flex-shrink: 0;
		width: 100%;

		&__title {
			font-size: .8rem;
			color: $colorGray;
			line-height: 1.2;
		}
		&__item {
			margin-bottom: 1rem;
			h4 {
				font-size: .8rem;
				color: $colorGray;
				line-height: 1.2;
			}
			p {
				font-family: $fontFamilyBase;
				line-height: 1.2;
			}
		}

		@include mq($from: medium) {
			width: 25%;
		}
	}

</style>



// WEBPACK FOOTER //
// ProjectFacts.vue?4aad0e22